var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preloader",class:{'is-loaded': _vm.load}},[_c('div',{staticClass:"pl-l"}),_c('div',{staticClass:"pl-r"}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pl-line"},[_c('div')])
}]

export { render, staticRenderFns }